import React, { PureComponent } from "react";
import { bool, func, number } from "prop-types";

import Modal from "../../shared/modal/modal";
import Button from "../../shared/button/button";
import PrepaidPanel from "@/components/subscriptions/prepaidPanel";

export default class NoFundsEsignModal extends PureComponent {
  static propTypes = {
    isOpen: bool,
    onSignWithEmail: func,
    onCancel: func,
    eSignCost: number,
  };

  renderFooter = () => {
    const { onCancel } = this.props;

    return <Button tid="generic.form.cancel" onClick={onCancel && onCancel} />;
  };

  renderRefillBtn = () => {
    const { eSignCost } = this.props;

    return (
      <PrepaidPanel
        className="rounded-xl border p-4"
        pendingAdjustment={-(eSignCost || 0)}
      />
    );
  };

  renderProceedWithEmailSignBtn = () => {
    const { onSignWithEmail } = this.props;

    return (
      <Button
        mode={"default"}
        tid="documents.esign.no_funds_modal.btn.proceed"
        onClick={onSignWithEmail && onSignWithEmail}
      />
    );
  };

  render = () => {
    const { isOpen } = this.props;

    return (
      <Modal
        title="documents.esign.no_funds_modal.title"
        isOpen={isOpen}
        hSize="md"
        vSize={50}
        scrollableContent={false}
        footerComponent={this.renderFooter()}
      >
        <div className="flex flex-col gap-8">
          <div className="pt-8">{this.renderRefillBtn()}</div>
          {this.renderProceedWithEmailSignBtn()}
        </div>
      </Modal>
    );
  };
}
